import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=2fd8af85&scoped=true"
import script from "./icons.vue?vue&type=script&lang=js"
export * from "./icons.vue?vue&type=script&lang=js"
import style0 from "./icons.vue?vue&type=style&index=0&id=2fd8af85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8af85",
  null
  
)

export default component.exports